import React from 'react'
import FileGalleryList from '../../components/FileGalleryList'
import ListController from '../../components/ListController'
import { listFiles } from '../../api/files'

class FileGalleryContainer extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    const sortBys = [
      'mimeType',
      'name',
      'createdAt',
      'updatedAt',
      'updatedBy',
      'lastUsed'
    ]

    this.state = {
      layout: 'LIST',
      sortBys,
      fetchList: listFiles,
      initialSortBy: 'lastUsed'
    }
  }

  render () {
    const displayComponent = this.state.layout === 'LIST' &&
      FileGalleryList

    return <ListController
      {...this.props}
      {...this.state}
      displayComponent={displayComponent} />
  }
}

FileGalleryContainer.propTypes = {
}

export default FileGalleryContainer



// WEBPACK FOOTER //
// ./src/components/FileGallery/FileGalleryContainer.js